$(() => {
  if (!$('#item_groups_show, #item_groups-categories_index').length) {
    return
  }

  // 一覧
  if ($('#item_groups-categories_index').length) {
    // PC用
    $('.js-link-pc-show-items').on('click', (e) => {
      e.preventDefault()
      const item_group_id = $(e.target).data('item-group-id')
      $(`.js-pc-items-row-${item_group_id}`).removeAttr('style')
      $(e.currentTarget).addClass('d-none')
    })

    // モバイル用
    $('.js-link-mb-show-items').on('click', (e) => {
      e.preventDefault()
      const item_group_id = $(e.target).data('item-group-id')
      $(`.js-mb-items-row-${item_group_id}`).removeClass('d-none')
      $(e.currentTarget).addClass('d-none')
    })
  }

  // 詳細
  if ($('#item_groups_show').length) {
    // Slicker
    if ($('.js-thumbnail-slicker').length > 0) {
      let slicker = $('.js-thumbnail-slicker').slick({
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 7000,
        fade: true,
        cssEase: 'linear'
      })
    }
    if ($('.js-slicker').length > 0) {
      let slicker = $('.js-slicker').slick({
        arrows: false,
        fade: true,
      })
      $('.js-slicker-nav-item').on('mouseenter', (e) => {
        $('.js-slicker-nav-item').removeClass('active')
        self = $(e.target)
        self.addClass('active')
        $('.js-slicker ').slick('slickGoTo', self.data('index'))
      })
    }
  }
})
